import { Icon, IconProps } from "../Icon";

const ArrowRight = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 6L16.6 7.4L24.1 15H3V17H24.1L16.6 24.6L18 26L28 16L18 6Z"
      fill="currentColor"
    />
  </Icon>
);

export default ArrowRight;
